import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Fostering.css";
import RegistrationModal2 from "../../components/RegistrationModal2";

const Fostering = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Temporary care solutions for your pets when you're away</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Service Card */}
        <div className="service-section">
          <div className="container">

            <div className="service-card">
              <div className="row">
                <div className="col-md-5">
                  <div className="service-content">
                    <h1 className="font-bold mb-4">
                      Fostering & Pet-sitters
                    </h1>
                    <p className="font-semibold">
                      Temporary care solutions for your pets when you're away. Our trusted foster and pet-sitting services ensure your pet receives love and attention in a safe environment.
                    </p>
                    <p>
                      Whether you need daily visits or extended care, our verified caregivers provide personalized attention, regular updates, and peace of mind for you and your pet.
                    </p>
                    <a className="btn btn-dark rounded-pill px-4 w-50 mt-4 font-semibold py-2" data-bs-toggle="modal" data-bs-target="#RegistrationModal2">
                      Join Us Now
                    </a>
                  </div>
                </div>
                <div className="col-md-7 pe-0">
                  <div className="service-image">
                    <img
                      className="w-100"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/services_icon/fostering.png`}
                      alt="Fostering"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Registration Modal 2 for Service Providers */}
        <RegistrationModal2 preSelectedService="fostering" />
      </section>
    </>
  );
};

export default Fostering;
